export const TOGGLE_BRAND = 'TOGGLE_BRAND';

export const setBrand = brand => ({
  type: TOGGLE_BRAND,
  value: {brand},
});
